import styled from "@emotion/styled";

// Assets
import IconBreathe from "../../../../../assets/images/roofing/icons/icon_breathe.svg";
const IconSeal = "https://imagecdn.owenscorning.com/ocimages/image/upload/v1661545059/roofing/widgets/quoting-widget/icons/icon-seal.svg";
const IconDefend = "https://imagecdn.owenscorning.com/ocimages/image/upload/v1661545059/roofing/widgets/quoting-widget/icons/icon-defend.svg";

// Components
import { H3 } from "../../../OC/oc-h";

// Styled Components
const Group = styled.div`
  display: inline-block;
  margin-bottom: 8px;
  position: relative;
  width: 100%;
`;

const Badge = styled.div`
  background-color: #D40F7D;
  color: #FFFFFF;
  display: inline-block;
  font-family: Oswald;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  padding: 0 4px;
  position: relative;
  text-transform: uppercase;
  width: 120px;

  &.defend {
    background-color: #6D6D6D;
  }

  &.breathe {
    background-color: #BCBCBC;
    color: #000000;
  }
`;

const Icon = styled.div`
  background-image: url('${props => props.url}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 16px;
  margin-right: 5px;
  position: relative;
  width: 16px;
`;

const Strong = styled.strong`
  display: block;
  margin-bottom: 5px;
`;

const P = styled.p`
  margin: 0 0 16px;
`;

const RoofingComponentsModal = ({}) => {
  return (
    <>
      <H3>Roofing Components</H3>

      <Group>
        <Badge>
          <Icon url={IconSeal} />
          Seal.
        </Badge>
        <Strong>Ice & Water Barrier</Strong>
        <P>Helps protect the roof where water has a tendency to collect or flow, including valleys, eaves, chimneys and skylights.</P>
        <Strong>Synthetic Underlayment</Strong>
        <P>Provides a water-shedding barrier under shingles to guard against wind-driven rain.</P>
      </Group>

      <Group>
        <Badge className="defend">
          <Icon url={IconDefend} />
          Defend.
        </Badge>
        <Strong>Starter Shingles</Strong>
        <P>Ensure a straight edge and effective seal along the eaves and rake—areas that are vulnerable to high winds.</P>
        <Strong>Laminate Shingles</Strong>
        <P>Provide protection and curb appeal in a wide array of colors and styles.</P>
        <Strong>Hip & Ridge Shingles</Strong>
        <P>Extra protection and stylish dimension along the hips and ridges. Designed to match and complement Owens Corning® shingles.</P>
      </Group>

      <Group>
        <Badge className="breathe">
          <Icon url={IconBreathe} />
          Breathe.
        </Badge>
        <Strong>Intake & Exhaust Vents</Strong>
        <P>Help protect the interior components of the roofing system from heat and moisture damage.</P>
      </Group>
    </>
  );
};

export default RoofingComponentsModal;
